import "./Controller.scss";

const Controller = (props: { children: any; className: any }) => {
	return (
		<div className={` controller controller--${props.className}`}>{props.children}</div>
	);
};

export default Controller;
